<!------------------------------------------------------------------------------
 File: ActionsMenuModule 
 Created by keni.
 with: IntelliJ IDEA
 Date: 25/04/2018
 Time: 10:23
------------------------------------------------------------------------------->
<template>
    <div class="menu-more">
        <div class="menu--more-trigger" :class="{
        'menu-more--active':menu_open==true
        }"
        >
            <i v-on:click="openMenu" class="material-icons">more_vert</i>
        </div>

        <transition-group
                name="slideDown"
                tag="div"
                class="menu--more-list"
        >
            <div v-if="menu_open==true && hide_calendar !== true"
                    v-on:click="actionEvent('calendar')"
                    class="menu--more-list--item"
                    key="calendar"
            >
                <i class="material-icons"
                >event</i>
            </div>

            <download-excel
                    key="download"
                    v-if="menu_open==true && download.data.length > 0"
                    :name="download.name"
                    :type="download.type"
                    :fields="download.fields"
                    :data="download.data"

                    class="menu--more-list--item"

            >
                <i class="cursor-pointer material-icons"
                >file_download</i>
            </download-excel>
        </transition-group>

    </div>
</template>

<script>
	import JsonExcel from '../export/JsonExcel'; //https://github.com/jecovier/vue-json-excel

	Vue.component('downloadExcel', JsonExcel);

	export default {
		name: "actions-menu-module",
		components: {},
		props: {
			/**
			 * @property {string} download.type     - mime type [xls, csv], default: xls
			 * @property {string} download.name     - filename to export, deault: data.xls
			 * @property {object} download.fields   - fields inside the Json Object that you want to export
			 *                                      - if no given, all the properties in the Json are exported
			 * @property {object} download.data     - Json to download
			 * @namespace download
			 */
			download: Object,
            hide_calendar: Boolean
		},
		created() {
		},
		destroyed() {
		},
		mounted() {
			// console.log('this.download', this.download);
		},
		data() {
			return {
				menu_open: false
			}
		},
		methods: {
			openMenu() {
				this.menu_open = !this.menu_open;
			},
			actionEvent(action) {
				this.$emit('click_events', {
					action: action
				})
			}
		},
		watch: {
			download(download) {
				// console.log('download', download);
			}
		},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modules/ActionsMenuModule.vue?5aa81b8e